/**
 * Client Context - React Context 定义
 *
 * 运行时层在根组件中注入以下 Context，使所有模块的组件都能访问全局注册的资源。
 */
import { createContext } from 'react';
/** 组件注册表 Context */
export const ClientComponentsContext = createContext({});
/** 全局状态 Context */
export const ClientGlobalStateContext = createContext({});
/** 服务注册表 Context */
export const ClientServicesContext = createContext({});
/** Hooks 注册表 Context */
export const ClientHooksContext = createContext({});
//# sourceMappingURL=context.js.map